<div id="divContract" class="dropdown">
  <label id="lblContract" *ngIf="!isQuickAuditRerun" class="contractperiod"> Contract Year </label>
  <kendo-dropdownlist *ngIf="!isQuickAuditRerun" id="ddlContract" [data]="contractYearList" [value]="selectedContractYear" [valuePrimitive]="true"
    (selectionChange)="OnContractYearChanged($event)" [popupSettings]="contractYearDropdownPopupSettings">
  </kendo-dropdownlist>
</div>


<div id="divCustomer" class="dropdown" *ngIf="showAccountdropdown && !isQuickAuditRerun">
  <label id="lblCustomer" class="contractperiod"> Account </label>

  <kendo-dropdownlist id="ddlRfpAccounts" [data]="rfpAccountList" valueField="channelID" textField="name"
    [valuePrimitive]="true" [value]="rfpAccountid" (selectionChange)="OnRfpAccountsChanged($event)"
    [popupSettings]="rfpAccountsDropdownPopupSettings">
  </kendo-dropdownlist>
</div>
